module.exports = __webpack_public_path__ + "img/banner-tc5-m.05305223.jpg";